// keywordAutocomplete/liveHighlight.js — live per-keystroke hidden-keyword highlight for a contenteditable
// keyword field. Wraps each comma-keyword that satisfies isHidden(kw) in a <mark class="topo2-editor-hidden">
// (the existing accent style), re-rendering el.innerHTML only when it actually changes and keeping the caret in
// place via the caret utils. This is the "input → re-mark + caret-restore" path — the thing the textarea+hwt
// backdrop did for free, done here for contenteditable.

import { caretCharOffset, setCaretCharOffset } from "./caretWord.js";

function escapeHtml(s) {
    return s.replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));
}

// Build the marked-up HTML for a comma-delimited keyword string. Pure — unit-testable without the DOM.
export function highlightHtml(text, isHidden) {
    return text.split(/(,)/).map((seg) => {
        if (seg === ",") { return ","; }
        const kw = seg.trim();
        if (kw && isHidden(kw)) {
            const i = seg.indexOf(kw);
            return escapeHtml(seg.slice(0, i)) +
                '<mark class="topo2-editor-hidden">' + escapeHtml(kw) + "</mark>" +
                escapeHtml(seg.slice(i + kw.length));
        }
        return escapeHtml(seg);
    }).join("");
}

// Apply the highlight to `el` in place, preserving the caret. No-op if nothing changed (so plain typing doesn't
// disrupt the caret every keystroke).
export function applyHiddenHighlight(el, isHidden) {
    const html = highlightHtml(el.textContent, isHidden);
    if (html === el.innerHTML) { return; }
    const offset = caretCharOffset(el);
    el.innerHTML = html;
    if (offset !== null) { setCaretCharOffset(el, offset); }
}
